<template>
  <navbar
    position="fixed"
    type="primary"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template slot-scope="{ toggle, isToggled }">
      <router-link v-popover:popover1 class="navbar-brand" to="/">
        <img src="img/logoSmall.png" width="60%" alt="" />
      </router-link>

    </template>





    <template slot="navbar-menu">

      <li class="nav-item">
        <router-link v-popover:popover1 class="nav-link" to="/explorer">
          <i class="now-ui-icons location_map-big"></i>
            Dashboard
        </router-link>
      </li>


      <li class="nav-item">
        <router-link v-popover:popover1 class="nav-link" to="/#products" @click.native="scrollTo('/#products')">
          <i class="now-ui-icons design_app"></i>
          Products
        </router-link>
      </li>

      <li class="nav-item">
        <router-link v-popover:popover1 class="nav-link" to="/documentation">
          <i class="now-ui-icons files_single-copy-04"></i>
          Documentation
        </router-link>
      </li>





      <li class="nav-item" v-if="signedIn">
        <i
          class="nav-link btn btn-neutral"
          v-on:click="signOut()"
        >
          <i class="now-ui-icons objects_key-25"></i>
          <p>Sign out</p>
        </i>
      </li>

    </template>
  </navbar>
</template>

<script>
const TIMEOUT = 1;
import { DropDown, NavbarToggleButton, Navbar, NavLink } from '@/components';
import { Popover } from 'element-ui';
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Auth } from 'aws-amplify';
export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavbarToggleButton,
    NavLink,
    [Popover.name]: Popover
  },
  data() {
    return {
      signedIn: false
    }
  },
  beforeCreate() {
    AmplifyEventBus.$on('authState', info => {
      if (info === 'signedIn') {
        this.signedIn = true
        this.$router.push(this.$route.query.redirect || '/')
      }
      if (info === 'signedOut') {
        this.$router.push('/auth')
        this.signedIn = false
      }
    });
    Auth.currentAuthenticatedUser()
      .then(user => {
        this.signedIn = true
      })
      .catch(() => this.signedIn = false)
  },
  mounted () {
  // From testing, without a brief timeout, it won't work.
    if (this.$route.hash) {
      setTimeout(() => this.scrollTo(this.$route.hash), TIMEOUT)
    }
  },
  methods:{
    signOut() {
      Auth.signOut().then(() => {
        this.$router.push('/')
        this.signedIn = false
      });

    },
    scrollTo: function (hashtag) {
      setTimeout(() => { location.href = hashtag }, TIMEOUT)
    }
  }
};
</script>

<style scoped></style>
